<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="About Us" pageTitle="About Us" />
            <AboutUs />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AboutUs from '../AboutUs/AboutUs'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AboutUsPage',
    components: {
        MainHeader,
        PageTitle,
        AboutUs,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>